import { getWalletClient } from '@wagmi/core';
import { IdentifierKind } from '@xmtp/browser-sdk';
import { toBytes } from 'viem';
import type { HorusSigner } from './types';

async function getWalletClientWithRetry(): Promise<any> {
  let walletClient = await getWalletClient();
  if (!walletClient) {
    // Retry after short delay — wagmi may still be auto-connecting on page load
    await new Promise(r => setTimeout(r, 2000));
    walletClient = await getWalletClient();
  }
  if (!walletClient) {
    throw new Error('No wallet client available. Please reconnect your wallet.');
  }
  return walletClient;
}

export function createNonCustodialSigner(address: string): HorusSigner {
  const normalizedAddress = address.toLowerCase();

  return {
    type: 'EOA',
    getIdentifier: () => ({
      identifier: normalizedAddress,
      identifierKind: IdentifierKind.Ethereum,
    }),
    signMessage: async (message: string): Promise<Uint8Array> => {
      const walletClient = await getWalletClientWithRetry();
      const signature = await walletClient.signMessage({
        account: address as `0x${string}`,
        message,
      });
      return toBytes(signature);
    },
    signMessageHex: async (message: string): Promise<string> => {
      const walletClient = await getWalletClientWithRetry();
      return walletClient.signMessage({
        account: address as `0x${string}`,
        message,
      });
    },
  };
}
